export function getQuestionFileName(lernfeld, quizType, quizLevel) {

    let questionFileName = "";

    if (quizType === 'textquiz') {
        if (quizLevel === 'easy')
        {
            questionFileName = `${lernfeld}/TextLeicht.json`;
        }
        else if (quizLevel === 'medium')
        {
            questionFileName = `${lernfeld}/TextMittel.json`;
        }
        else if (quizLevel === 'hard')
        {
            questionFileName = `${lernfeld}/TextSchwer.json`;
        }
        else 
        {
            questionFileName = "";
        }
    }

    if (quizType === 'bildquiz') {
        if (quizLevel === 'easy')
        {
            questionFileName = `${lernfeld}/BildLeicht.json`;
        }
        else if (quizLevel === 'medium')
        {
            questionFileName = `${lernfeld}/BildMittel.json`;
        }
        else if (quizLevel === 'hard')
        {
            questionFileName = `${lernfeld}/BildSchwer.json`;
        }
        else 
        {
            questionFileName = "";
        }
    }                

    if (quizType === 'audioquiz') {
        if (quizLevel === 'easy')
        {
            questionFileName = `${lernfeld}/AudioLeicht.json`;
        }
        else if (quizLevel === 'medium')
        {
            questionFileName = `${lernfeld}/AudioMittel.json`;
        }
        else if (quizLevel === 'hard')
        {
            questionFileName = `${lernfeld}/AudioSchwer.json`;
        }
        else 
        {
            questionFileName = "";
        }
    }

    return questionFileName;
}

export function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]; // swap
  }
  return array;
}